// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7a788806","453":"d4163cc7","455":"94bd1d58","977":"25a8e849"}[chunkId] + ".chunk.js";
};